import { AppModulesService } from '@/modules/shared/services/app-module.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

const appModulesService = new AppModulesService();

export const state = {
  appModules: []
};
export const mutations = {
  ...make.mutations(state)
};
export const actions = {
   getAppModules: async ({ commit }) => {
    try {
      const { data } = await appModulesService.getAppModules();
      const allSelectedModules = data && Array.isArray(data.selectedModules) ? data.selectedModules : [];
      const activeModules = allSelectedModules;
      commit('SET_APP_MODULES', activeModules);
      commit('featureFlagModule/PROCESS_DELINQUENCY_FEATURES', allSelectedModules, { root: true });
      return { ...data, selectedModules: activeModules };
    } catch (error) {
      Logger.error('getting app modules', error);
      throw error;
    }
  },

  getModuleByName: async (_, name) => {
    try {
      const { data } = await appModulesService.getModuleByName(name);
      return data;
    } catch (error) {
      Logger.error('getting app modules by name', error);
      throw error;
    }
  },
  getModuleWithProcesses: async () => {
    try {
      const { data } = await appModulesService.getModuleWithProcesses();
      return data;
    } catch (error) {
      Logger.error('getting app modules with processes', error);
      throw error;
    }
  },
  getModuleNamesOnly: async () => {
    try {
      const { data } = await appModulesService.getModuleNamesOnly();
      return data;
    } catch (error) {
      Logger.error('getting app modules names only', error);
      throw error;
    }
  }
};

export const getters = {
  ...make.getters(state),
  // getter that returns all active modules
  getActiveModules: (state) => {
    return (state.appModules || []);
  },
  // Getter that returns the names of all active modules
  activeModuleNames: (state) => {
    return (state.appModules || [])
      .map((module) => module.appName);
  }
};
